export default __webpack_public_path__ + "static/media/SeaLife_25.8d6d69df.png";